import { useMemo } from "react"
import { isMobile as isMobileDevice, isChrome } from "react-device-detect"

export function useIsMobileDevice() {
  const env = useMemo(() => {
    const ua = typeof navigator === "undefined" ? "" : navigator.userAgent

    const isPhantom = /Phantom/i.test(ua)
    const isBackpack = /Backpack/i.test(ua)
    const isSolflare = /Solflare/i.test(ua)

    const isMobile = isMobileDevice || isPhantom || isBackpack || isSolflare

    return {
      isMobile,
      isPhantom,
      isBackpack,
      isSolflare,
      isInWalletBrowser: isPhantom || isBackpack || isSolflare,
      isChrome,
    }
  }, [])

  return env
}
